import "./style.css";

const Head = (props) => {
	let cls = ["skin-form-head-ttl-com-lst-head", "form-head-ttl-com-lst-head"];
	cls = cls.join(" ");
	return <div className={cls}>Экраны</div>;
};

export default Head;
